<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <file-input
      v-model="forwardDocumentFile"
      :is_uploaded="file('ud_1') ? file('ud_1') : null"
      class="form__input-container"
      componentID="forward-document"
    >
      <h3 class="form__heading">
        {{ $t("document photo front") }}
      </h3>
      <p class="form__paragraph">
        {{ $t("passport driving license internal passport") }}
      </p>
    </file-input>
    <file-input
      :is_uploaded="file('ud_2') ? file('ud_2') : null"
      v-model="backwardDocumentFile"
      class="form__input-container"
      componentID="backward-document"
    >
      <h3 class="form__heading">
        {{ $t("document photo back") }}
      </h3>
    </file-input>
    <button type="submit" class="button filled form__button">
      {{ file("ud_1") && file("ud_2") ? $t("continue") : $t("send files") }}
    </button>
  </form>
</template>

<script>
import FileInput from "@/components/register/FileInput";
import RegFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  components: {
    "file-input": FileInput
  },
  props: ["user_profile"],
  data() {
    return {
      forwardDocumentFile: null,
      forwardDocumentFileStatus: false,
      backwardDocumentFile: null,
      backwardDocumentFileStatus: false
    };
  },
  mixins: [RegFormMixin],
  methods: {
    file(type) {
      return this.user_profile.userUploadedDocuments.find(
        file => file.type === type
      );
    },
    nextStep() {
      this.$router.push({
        name: "register-finish"
      });
    },
    sendRegisterDocuments() {
      let files = [this.forwardDocumentFile, this.backwardDocumentFile];
      return new Promise(async (resolve, reject) => {
        for (var i = 0; i < files.length; i++) {
          let file = files[i];
          let url = `signup/file-upload`;
          if (file !== null) {
            let formData = new FormData();
            formData.append("file", file);
            formData.append("type", `ud_${i + 1}`);
            const { data } = await FhsAxios.post(url, formData);
            if (data.status) {
              this.$toasted.success(
                `${i + 1} - ` + this.$t("document uploaded")
              );
            } else {
              reject(data);
            }
          }
        }
        resolve();
      });
    },
    handleFormSubmit: function() {
      try {
        if (this.isDataValid()) {
          this.sendRegisterDocuments()
            .then(counter => {
              this.nextStep();
            })
            .catch(e => {
              this.$toasted.error(this.$t("file upload error"));
            });
        }
      } catch (e) {}
    },
    // Валидируем поля для загрузки файлов
    isDataValid() {
      if (
        (this.forwardDocumentFile || this.file("ud_1")) &&
        (this.backwardDocumentFile || this.file("ud_2"))
      ) {
        return true;
      }
      this.$toasted.clear();
      this.$toasted.show(this.$t("attach files"));
      return false;
    }
    // ...mapActions(["sendRegisterDocuments"])
  },
  beforeMount() {
    // this.fetchForm();
  }
};
</script>

<style scoped>
.form {
  color: #ffffff;
}

.form__heading {
  margin-bottom: 15px;
  font-size: 18px;
}

.form__paragraph {
  margin-bottom: 15px;
  font-size: 13px;
}

.form__button {
  width: 100%;
  margin-top: 20px;
  padding: 15px 0;
  font-size: 15px;
}
</style>
